import { render, staticRenderFns } from "./PushNotificationsLoading.vue?vue&type=template&id=75a454aa&scoped=true&"
import script from "./PushNotificationsLoading.vue?vue&type=script&lang=js&"
export * from "./PushNotificationsLoading.vue?vue&type=script&lang=js&"
import style0 from "./PushNotificationsLoading.vue?vue&type=style&index=0&id=75a454aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75a454aa",
  null
  
)

export default component.exports